import { render, staticRenderFns } from "./SingleCourse.vue?vue&type=template&id=10355576&scoped=true"
import script from "./SingleCourse.vue?vue&type=script&lang=ts"
export * from "./SingleCourse.vue?vue&type=script&lang=ts"
import style0 from "./SingleCourse.vue?vue&type=style&index=0&id=10355576&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10355576",
  null
  
)

export default component.exports